import React from "react";
import Create from "../Create";
import Update from "./Update";
import Delete from "./Delete";
import Price from "./Price";
import Uploader from "./Uploader";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import {
  Fade,
  Card,
  Stack,
  IconButton,
  Typography,
  CardHeader,
  CardActionArea,
  CardContent,
} from "@mui/material";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  selectable,
  handleSelect,
  showChildren,
}) {
  const { id, title, alias, media, children } = model;
  const avatar = media.find((x) => x.collection_name === "avatar");

  const labRoles = ["labManager"];
  const roles = ["superadmin", "operator"];

  const { userInfo } = useSelector((state) => state.auth);
  const hasRole = hasRequiredRole(roles, userInfo?.roles);
  const isLabAdmin = hasRequiredRole(labRoles, userInfo?.roles);

  return (
    <>
      <Fade
        in
        unmountOnExit
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: "100%",
              position: "relative",
              borderColor: checked && "primary.main",
              bgcolor: checked && "action.disabledBackground",
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <Uploader
                  id={id}
                  media={avatar}
                  refetch={refetch}
                  model="ActionNew"
                  collection="avatar"
                  label=""
                  // caption="400 * 400"
                />
              }
              title={title}
              subheader={alias}
              action={
                <Stack direction="row" columnGap={0.5}>
                  {hasRole && (
                    <>
                      <Update id={id} refetch={refetch} />
                      <Delete id={id} refetch={refetch} />
                      {/* <Create ids={id} refetch={refetch} title="create" /> */}
                    </>
                  )}
                  <IconButton
                    size="small"
                    // disabled={children.length === 0}
                    onClick={() => showChildren(id)}
                    sx={{ bgcolor: "action.hover", zIndex: 2 }}
                  >
                    <KeyboardArrowLeftRoundedIcon fontSize="small" />
                  </IconButton>
                </Stack>
              }
            />
            {(isLabAdmin || hasRole) && (
              <CardContent>
                <Price id={id} refetch={refetch} />
              </CardContent>
            )}
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
